<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            v-model="imageExample.show"
            @hidden="$emit('close')" 
            hide-footer
            size="lg"
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <h3 class="mb-0">{{showImageExample.title}}</h3>
                        </div>

                    </div>
                </div>
            </template>
            <card shadow type="secondary" class="m--4">
                <div class="row">
                    <div class="col-3" v-for="(image , index) in showImageExample.images" :key="index">
                        <img :src="image" alt="BranceExample" width="150" height="180">
                    </div>
                </div>
            </card>
        </b-modal>
    </div>
</template>
<script>
    export default {
        name: "ModalImageExample",
        props: {
            imageExample: Object,
        },
        computed: {
            showImageExample(){
                if( this.imageExample.nameInput == 'frontArea' ){
                    return {
                        title:"ตัวอย่างรูปพื้นที่หน้าร้าน" ,
                        images:[require('../../../assets/images/shop_front_1.jpg'), require('../../../assets/images/shop_front_2.jpg'),require('../../../assets/images/shop_front_3.jpg'), require('../../../assets/images/shop_front_4.jpg')]
                    }
                }else if( this.imageExample.nameInput == 'environmentArea' ){
                    return {
                        title:"ตัวอย่างรูปสภาพแวดล้อมหน้าร้าน" ,
                        images:[require('../../../assets/images/shop_environ_1.jpg'), require('../../../assets/images/shop_environ_2.jpg'),require('../../../assets/images/shop_environ_3.jpg')]
                    }
                }else if( this.imageExample.nameInput == 'shopArea' ){
                    return {
                        title:"ตัวอย่างรูปพื้นที่ในร้าน" ,
                        images:[require('../../../assets/images/shop_area_1.jpg'), require('../../../assets/images/shop_area_2.jpg'),require('../../../assets/images/shop_area_3.jpg'), require('../../../assets/images/shop_area_4.jpg')]
                    }
                }else if( this.imageExample.nameInput == 'storageSpace' ){
                    return {
                        title:"ตัวอย่างรูปพื้นที่เก็บของ (หากมี)" ,
                        images:[require('../../../assets/images/shop_storage_1.jpg'), require('../../../assets/images/shop_storage_2.jpg'),require('../../../assets/images/shop_storage_3.jpg')]
                    }
                }else{
                    return {
                        title:"" ,
                        images:[]
                    }
                }
            }
        }   
    }
</script>
